<template>
    <div>
        <h1 style="text-align: center">欢迎使用</h1>
    </div>
</template>

<script>
export default {
    name: 'dashboard',
    data() {
        return {
            name: "",
        };
    },
    methods: {
    }
};
</script>


<style scoped>
</style>
